import "./src/components/layout.css"

const ROUTE_TRANSITION_DURATION = 360
const DEFAULT_THEME = "light-3"

let routeTransitionTimer = null

const setDefaultTheme = () => {
  if (typeof document === "undefined") return

  document.documentElement.setAttribute("data-theme", DEFAULT_THEME)
}

export const onClientEntry = () => {
  setDefaultTheme()
}

export const onPreRouteUpdate = () => {
  if (typeof document === "undefined") return

  setDefaultTheme()

  document.documentElement.classList.add("is-route-changing")
  document.documentElement.classList.remove("is-route-entering")

  if (routeTransitionTimer) {
    window.clearTimeout(routeTransitionTimer)
    routeTransitionTimer = null
  }
}

export const onRouteUpdate = ({ location }) => {
  if (typeof document === "undefined" || typeof window === "undefined") return

  setDefaultTheme()

  if (!location.hash) {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    })
  }

  document.documentElement.classList.remove("is-route-changing")
  document.documentElement.classList.add("is-route-entering")

  routeTransitionTimer = window.setTimeout(() => {
    document.documentElement.classList.remove("is-route-entering")
    routeTransitionTimer = null
  }, ROUTE_TRANSITION_DURATION)
}

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  const savedPosition = getSavedScrollPosition(location)

  if (savedPosition) {
    return savedPosition
  }

  window.scrollTo(0, 0)
  return false
}